import { getNotificationTemplate } from '@/context/user-notifications/helpers/notification-template';
import { Notification } from '@/context/user-notifications/entities/notification';
import { useTranslation } from 'react-i18next';
import type { NotificationTemplate } from '../helpers/types';

const isNotificationTemplate = (
  notificationTemplate: NotificationTemplate | null
): notificationTemplate is NotificationTemplate => notificationTemplate !== null;

export const useUserNotificationTemplates = ({
  notifications,
}: {
  notifications: Notification[];
}): NotificationTemplate[] => {
  const { t } = useTranslation('notifications');
  return notifications
    ?.map((item) => getNotificationTemplate(item, t))
    .filter(isNotificationTemplate);
};
